import { render, staticRenderFns } from "./MailTemplates.list.vue?vue&type=template&id=fd1c9ab6&scoped=true&"
import script from "./MailTemplates.list.vue?vue&type=script&lang=js&"
export * from "./MailTemplates.list.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplates.list.vue?vue&type=style&index=0&id=fd1c9ab6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1c9ab6",
  null
  
)

export default component.exports